import React, {useState, useEffect, useRef} from 'react';
import {ArrowUpTrayIcon, XMarkIcon} from '@heroicons/react/24/outline';
import NavbarReturn from '../components/NavbarReturn';
import FooterAdmin from '../components/FooterAdmin';
import {database, storage} from '../config/firebaseConfig';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, setDoc, doc, getDocs, updateDoc, deleteDoc, query, orderBy} from "firebase/firestore";
import AlertOnLoading from '../components/AlertOnLoading';
import { Toaster } from 'react-hot-toast';
import AlertBox from '../components/AlertBox';
import {DndContext, closestCenter} from '@dnd-kit/core';
import {arrayMove, SortableContext, verticalListSortingStrategy} from '@dnd-kit/sortable';
import { SortableImage } from '../components/SortableImages';
import { LazyLoadImage } from "react-lazy-load-image-component";

function CampaignsAdmin() {
    const SUCCESS = "success"
    const WARNING = "warning"
    const DANGER = "danger"

    const [newData, setNewData] = useState(true);

    const [uploading, setUploading] = useState(false);
    const [updating, setUpdating] = useState(false);

    const notInitialRender = useRef(false);
    const WAIT_TIME = 2000; //Waits for 0.5s

    const [currentPage, setCurrentPage] = useState(1);
    const campaignsPerPages = 5;

    const [imageSelected, setImageSelected] = useState("Imagen");
    const [imageUpload, setImageUpload] = useState(null);
    const [imageURL, setImageURL] = useState('');
    const [campaignIdIdSelected, setCampaignIdSelected]= useState('');
    const [campaigns, setCampaigns] = useState(null);
    
    const [activeCampaigns, setActiveCampaigns] = useState([]);

    const lastCampaignIndex = currentPage * campaignsPerPages;
    const firstCampaignIndex = lastCampaignIndex - campaignsPerPages;

    function findWithAttribute(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }
    
    function handleDragEnd(event) {
        const {active, over} = event;

        if (active.id !== over.id) {
            const activeIndex = findWithAttribute(activeCampaigns, "id", active.id);
            const overIndex = findWithAttribute(activeCampaigns, "id", over.id);

            setActiveCampaigns(arrayMove(activeCampaigns, activeIndex, overIndex));
        }
    }

    const togglePopupDelete = (campaignId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${campaignId}`),function(itm){
          itm.style.display = "flex";
        })();
    }
  
    const closePopupDelete = (campaignId) =>{
        [].forEach.bind(document.getElementsByClassName(`popup_delete ${campaignId}`),function(itm){
            itm.style.display = "none";
        })();
    }

    /*
        It updates the text of the image's input
    */
    function updateText(event) {
        setImageUpload(event.target.files[0]);
        const newText = document.getElementById("uploadImage").value;
        const getFileName = newText.split("\\");
        setImageSelected(getFileName[getFileName.length - 1]);
    }

    /*
        It hides the PopUp of the Campaign
    */
    const closePopUpCampaign = (campaignId) => {
        const popup = document.getElementById(campaignId);
        setImageURL('');
        setCampaignIdSelected('');
        setImageSelected('Imagen');
        popup.classList.add('hidden');
        popup.classList.remove('flex');
    }
    
    /*
        It shows the PopUp of the Campaign
    */
    const togglePopUpCampaign = (campaignId, image) => {
        const popup = document.getElementById(campaignId);
        popup.classList.remove('hidden');
        popup.classList.add('flex');
        setImageURL(image);
        setCampaignIdSelected(campaignId);
        setImageSelected("Imagen")
    }
    
    /*
        It updates the text of the image's input for PopUp
    */
    function updateTextPopUp(event) {
        setImageUpload(event.target.files[0]);
        const newText = event.target.files[0];
        const getFileName = newText.name;
        setImageSelected(getFileName);
    }

    /*
        Creates a new Campaign 
    */
    async function createCampaign() {
        const campaignCollectionRef = collection(database, "campaigns");
        if (imageUpload == null) {
            AlertBox(WARNING, '¡Debe seleccionar una imagen!');
            return;
        } else {
            const addButton = document.querySelectorAll("#addRegister");
            addButton[0].setAttribute("disabled", true);

            setUploading(true);

            const imageRef = ref(storage, `images/${imageUpload.name}`);
            uploadBytes(imageRef, imageUpload).then(async () => {

                const imageURL = await getDownloadURL(imageRef);
                const newCampaignRef = doc(campaignCollectionRef);
                setDoc(newCampaignRef, {image: imageURL, state:false});

                setImageSelected("Imagen");
                setNewData(true);

                addButton[0].removeAttribute("disabled");

                setUploading(false);

                AlertBox(SUCCESS, '¡Campaña creada correctamente!');
                return;
            })
            .catch(error => {
                console.log("Error al subir la imagen: " + error);
                AlertBox(DANGER, '¡Ha ocurrido un error inesperado!');
                addButton[0].removeAttribute("disabled");

                setUploading(false);
                return;
            });
        }
    }

    async function setCampaignVisibility(campaignId, newState, imageURL) {
        
        const updateStateRef = doc(database, 'campaigns', campaignId);
        await updateDoc(updateStateRef, {state:newState});

        if (newState) {
            const newActiveCampaignRef = doc(database, "activeCampaigns", campaignId);
            setDoc(newActiveCampaignRef, {image: imageURL, position:activeCampaigns.length+1});
        } else {
            const activeCampaignDoc = doc(database, "activeCampaigns", campaignId);
            await deleteDoc(activeCampaignDoc);
        }

        setNewData(true);
        return;
    }

    const deleteNumbers = (selectedId) => {
        return selectedId.replace(/\d+/g, '');
    }

    async function updateCampaign() {
        if (imageSelected !== "Imagen") {
            const updateButton = document.querySelectorAll(`button.${deleteNumbers(campaignIdIdSelected)}`);
            updateButton[0].setAttribute("disabled", true);

            setUpdating(true);
            const imageRef = await ref(storage, `images/${imageUpload.name}`);
            
            uploadBytes(imageRef, imageUpload).then(async () => {
                const imageURL = await getDownloadURL(imageRef);
                const updateCampaignRef = doc(database, 'campaigns', campaignIdIdSelected);
                await updateDoc(updateCampaignRef, {image: imageURL});

                setImageSelected("Imagen");
                setNewData(true);
                updateButton[0].removeAttribute("disabled");

                setUpdating(false);
                AlertBox(SUCCESS, '¡Campaña actualizada correctamente!');
                closePopUpCampaign(campaignIdIdSelected);
                return;
            })
            .catch(error => {
                console.log("Error al subir la imagen: "+ error);
                AlertBox(DANGER, '¡Ha ocurrido un error inesperado!');
                updateButton[0].removeAttribute("disabled");

                setUpdating(false);
                return;
            });
        } else {
            closePopUpCampaign(campaignIdIdSelected);
            return;
        }
        
    }

    function updatePositionsActiveCampaigns() {
        activeCampaigns?.map(async (activeCampaign, newPosition) => {
            const updatePositionRef = doc(database, 'activeCampaigns', activeCampaign.index);
            await updateDoc(updatePositionRef, {position: newPosition+1});
        });
        setNewData(true);
    }

    /*
        Deletes a Campaign 
    */
    async function deleteCampaign(campaignId) {
        const campaignDoc = doc(database, "campaigns", campaignId);
        const activeCampaignDoc = doc(database, "activeCampaigns", campaignId);
        const index = findWithAttribute(campaigns, "id", campaignId);

        if (campaigns[index].state) {
            await deleteDoc(activeCampaignDoc);
        }
        
        await deleteDoc(campaignDoc);
        setNewData(true);
        AlertBox(SUCCESS, '¡Campaña eliminada correctamente!');
        closePopupDelete(campaignId)
    }

    /*
        Gets all active campaigns 
    */
        useEffect(() => {
            if (newData) {
                const activeCampaignsRef = collection(database, "activeCampaigns");
                const getActiveCampaigns = async() => {
                    const campaignQuery = query(activeCampaignsRef, orderBy("position"));
                    const data = await getDocs(campaignQuery);
                    setActiveCampaigns(data.docs.map((doc, index) => ({...doc.data(), id: index+1, index:doc.id})));
                }
                
                const interval = setInterval(() => { //Autorize re-render
                    getActiveCampaigns();
                    setNewData(!newData);
                }, WAIT_TIME);
                return () => clearInterval(interval);
            }
        }, [activeCampaigns, newData])

    /*
        Gets all campaigns 
    */
    useEffect(() => {
        if (notInitialRender.current && newData){
            AlertOnLoading(WAIT_TIME+100);
        }else {
            notInitialRender.current = true;
        } 
        
        if (newData) {
            const campaignsRef = collection(database, "campaigns");
            const getCampaigns = async() => {
                const data = await getDocs(campaignsRef);
                setCampaigns(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
            }
            
            const interval = setInterval(() => { //Autorize re-render
                getCampaigns();
                setNewData(!newData);
            }, WAIT_TIME);
            return () => clearInterval(interval);
        }
    }, [campaigns, newData])

    
    return (
        <div>
            <div>
                <Toaster
                    toastOptions={{
                    duration:3000,
                    }}
                />
            </div>

            <NavbarReturn />

            <div className="w-full h-navbar-mobile sm:h-navbar"/>

            <div className='lg:px-8 px-4 py-6 flex flex-col w-full h-auto bg-white min-h-screen'>
                <h2 className='lg:text-xl'>Crear una Campaña</h2>
                <span className='lg:w-80 w-48 border border-primary-100'></span>

                <div className="h-52 space-y-4 px-4 py-6 w-60 sm:flex sm:flex-col sm:w-96 sm:justify-start lg:w-input-web">
                    <div className='relative w-full h-input-height py-1 px-3 overflow-hidden
                        text-navFont-100 bg-primary-300 focus:outline-none 
                        focus:border focus:border-primary-100 focus:shadow-md mt-4'>
                        <div className='w-40 sm:w-72 md:w-72 lg:w-96 overflow-hidden'>
                            <label htmlFor="file" id="fileName" className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} text-sm md:text-base`}>{imageSelected}</label>
                        </div>
                        <div className='absolute inset-y-0 right-0 flex items-center'>
                            <ArrowUpTrayIcon className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} h-4 w-4 md:h-5 md:w-5 mx-2 hover:cursor-pointer`} />
                        </div>
                        <input onChange={updateText} id="uploadImage" className='w-full absolute file:w-full opacity-0 cursor-pointer left-0 -top-0 h-input-height' 
                        aria-hidden='true' type={"file"} accept=".jpeg, .jpg, .png, .webp, .svg" />
                    </div>

                    <button onClick={createCampaign} id="addRegister"
                        className='w-full h-8 text-sm sm:text-base sm:w-full sm:h-9 bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200 disabled:bg-primary-200'>
                        {!uploading? 
                        "Agregar"
                        : 
                        <div className="w-full flex justify-center items-center"> 
                            <svg fill='none' className="w-6 h-6 sm:w-8 sm:h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                            <path clipRule='evenodd'
                                d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                fill='currentColor' fillRule='evenodd' />
                            </svg> 
                            Agregando
                        </div>}
                    </button>
                </div>

                <h2 className='lg:text-xl mt-4'>Todas las Campañas</h2>
                <span className='lg:w-80 w-48 border border-primary-100'></span>

                <div className='w-full flex flex-row justify-center'>
                    <div className='w-full flex flex-col justify-center items-center'>
                    {campaigns? campaigns.slice(firstCampaignIndex, lastCampaignIndex).map((campaign, id)=> (
                        <div className='w-full flex justify-center' key={id}>
                            <div className='max-w-6xl w-4/5 p-2 gap-2 grid grid-rows-7 mt-6 border border-primary-100 md:flex md:flex-col'>
                                
                                <div className='hidden md:grid grid-cols-2 gap-2'>

                                    <div className='flex flex-col space-y-2'>
                                        <div className='bg-primary-300 w-full h-9 flex justify-center items-center'>
                                            <h3 className='text-primary-100 text-sm lg:text-lg'>Imagen</h3>
                                        </div>

                                        <div className='bg-background w-full h-40 flex justify-center items-center'>
                                            <LazyLoadImage src={campaign.image} className='w-full h-full max-h-80 object-cover'
                                            alt=''></LazyLoadImage>
                                        </div>
                                    </div>

                                    <div className='flex flex-col space-y-2'>
                                        <div className=' bg-primary-300 w-full h-9 flex justify-center items-center'>
                                            <h3 className='text-primary-100 text-sm lg:text-lg'>Visible</h3>
                                        </div>

                                        <div className=' bg-white w-full h-14 flex justify-center items-center cursor-pointer'
                                            onClick={() => setCampaignVisibility(campaign.id, !campaign.state, campaign.image)}>
                                            <div className={`flex w-2/3 h-14 bg-primary-300 rounded-full items-center px-1 ${campaign.state? 'justify-end': 'justify-start'}`}>
                                                {
                                                    campaign.state?
                                                    <div className='flex justify-center items-center w-12 h-12 bg-primary-100 rounded-full text-white font-light'>SÍ</div>
                                                    :
                                                    <div className='flex justify-center items-center w-12 h-12 bg-danger rounded-full text-white font-light'>NO</div>
                                                }
                                            </div>
                                        </div>
                                        
                                        <div className='w-full h-1 flex justify-center items-center'>
                                        </div>

                                        <div className=' bg-primary-300 w-full h-9 flex justify-center items-center'>
                                            <h3 className='text-primary-100 text-sm lg:text-lg'>Acción</h3>
                                        </div>

                                        <div className=' w-full h-10 flex justify-center items-center bg-background'>
                                            <div className='mr-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                                <button onClick={() => {togglePopUpCampaign(campaign.id, campaign.image)}}
                                                className='w-full h-7 text-sm lg:text-base sm:h-10 bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Editar Campaña</button>
                                            </div>
                                            <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                                <button onClick={() => {togglePopupDelete(campaign.id)}}
                                                className='w-full h-7 text-sm lg:text-base sm:h-10 bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar Campaña</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                    <h3 className='text-primary-100 text-sm'>Imagen</h3>
                                </div>

                                <div className='md:hidden bg-background w-full h-auto flex justify-center items-center '>
                                    <LazyLoadImage src={campaign.image} className='w-full h-auto max-h-40 object-contain'
                                    alt=''></LazyLoadImage>
                                </div>

                                <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                    <h3 className='text-primary-100 text-sm'>Visible</h3>
                                </div>

                                <div className='md:hidden bg-white w-full h-9 flex justify-center items-center cursor-pointer'
                                    onClick={() => setCampaignVisibility(campaign.id, !campaign.state, campaign.image)}>
                                    <div className={`flex w-1/2 h-10 bg-primary-300 rounded-full items-center px-1 ${campaign.state? 'justify-end': 'justify-start'}`}>
                                        {
                                            campaign.state?
                                            <div className='flex justify-center items-center w-9 h-9 bg-primary-100 rounded-full text-white font-light'>SÍ</div>
                                            :
                                            <div className='flex justify-center items-center w-9 h-9 bg-danger rounded-full text-white font-light'>NO</div>
                                        }
                                    </div>
                                </div>
                                
                                <div className='md:hidden bg-primary-300 w-full h-9 flex justify-center items-center'>
                                    <h3 className='text-primary-100 text-sm'>Acción</h3>
                                </div>

                                <div className='md:hidden w-full h-9 flex justify-center items-center bg-background'>
                                    <div className='mr-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                        <button onClick={() => {togglePopUpCampaign(campaign.id, campaign.image)}}
                                        className='w-full h-9 text-xs sm:text-base bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Editar Campaña</button>
                                    </div>
                                    <div className='ml-1 bg-background w-1/2 h-9 flex justify-center items-center'>
                                        <button onClick={() => {togglePopupDelete(campaign.id)}}
                                        className='w-full h-9 text-xs sm:text-base bg-danger text-white rounded-md font-bold hover:bg-red-400'>Eliminar Campaña</button>
                                    </div>
                                </div>
                            </div>
                            
                            <div className={`hidden fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-30 items-center justify-center`} id={campaign.id}> 
                                <div className='relative sm:max-w-3xl w-full flex flex-col justify-center py-3 items-center mx-10 sm:mx-5 sm:px-3 h-auto bg-white rounded overflow-y-auto'>
                                    <div className='w-full flex flex-col items-center justify-center mt-3'>
                                        <h2 className='flex flex-row md:text-xl'>Editar una Campaña</h2>
                                        <span className='md:w-80 w-48 h-px border border-primary-100'></span>
                                    </div>
                                    <button onClick={() => {closePopUpCampaign(campaign.id)}} className='absolute top-1 right-1 hover:text-primary-100'><XMarkIcon className='w-7 h-7'/></button>
                                    <div className='sm:static sm:space-x-3 sm:items-start sm:flex-row relative w-full flex flex-col justify-center py-3 items-center mx-0 h-auto bg-white rounded overflow-y-auto'>
                                        <div className='w-full flex flex-col items-center justify-center'>

                                            <div className='relative w-52 h-input-height py-1 px-3 overflow-hidden sm:w-5/6
                                                text-input-font bg-primary-300 focus:outline-none 
                                                focus:border focus:border-primary-100 focus:shadow-md mt-3'>
                                                <div className='w-40 sm:w-96 md:w-input-web overflow-hidden'>
                                                    <label htmlFor="file" id="fileName" className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} text-sm md:text-base`}>{imageSelected}</label>
                                                </div>
                                                <div className='absolute inset-y-0 right-0 flex items-center'>
                                                    <ArrowUpTrayIcon className={`${imageSelected==="Imagen"? "text-placeholder":"text-input-font"} h-4 w-4 md:h-5 md:w-5 mx-2 hover:cursor-pointer`} />
                                                </div>
                                                <input onChange={updateTextPopUp} id="uploadImage" className='w-full absolute file:w-full opacity-0 cursor-pointer left-0 -top-0 h-input-height' 
                                                aria-hidden='true' type={"file"} accept=".jpeg, .jpg, .png, .webp, .svg" />
                                            </div>
                                            
                                            <div className='w-52 mt-1 flex flex-col bg-primary-300 py-2 px-3 sm:w-5/6'>
                                                <h4 className='sm:text-base text-sm text-input-font'>Imagen anterior:</h4>
                                                <LazyLoadImage className='w-full h-full max-h-60 object-cover lg:object-fit' src={imageURL} alt="">
                                                </LazyLoadImage>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='w-52 mt-3 flex flex-row'>
                                        <button onClick={updateCampaign}
                                            className={`w-full h-8 text-sm sm:text-base sm:h-9 bg-primary-100 text-white rounded font-bold hover:bg-primary-200 disabled:bg-primary-200 ${deleteNumbers(campaign.id)}`}>
                                            {!updating? 
                                            "Guardar"
                                            : 
                                            <div className="w-full flex justify-center items-center"> 
                                                <svg fill='none' className="w-6 h-6 sm:w-8 sm:h-8 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                                <path clipRule='evenodd'
                                                    d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                                    fill='currentColor' fillRule='evenodd' />
                                                </svg> 
                                                Guardando
                                            </div>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            <div className={`hidden relative z-40 popup_delete ${campaign.id}`} aria-labelledby="modal-title" role="dialog" aria-modal="true" >
                                <div className="fixed inset-0 bg-popup"></div>

                                <div className="fixed inset-0 z-10 overflow-y-auto">
                                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                            <div className="sm:flex sm:items-start">
                                            <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                                <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                                                </svg>
                                            </div>
                                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">Eliminar Registro</h3>
                                                <div className="mt-2">
                                                <p className="text-sm text-gray-500">¿Está seguro que desea eliminar este registro? Este registro no se podrá recuperar. </p>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                            <button onClick={() => {deleteCampaign(campaign.id);}} type="button" className="inline-flex w-full justify-center rounded-md border border-transparent bg-danger px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-400 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">Eliminar</button>
                                            <button onClick={() => {closePopupDelete(campaign.id);}} type="button" className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Cancelar</button>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                    :
                    <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                        <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                            <path clipRule='evenodd'
                                d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                fill='currentColor' fillRule='evenodd' />
                        </svg>
                        <div>
                            Cargando...
                        </div>
                    </div>
                    }

                    <div className={`${campaigns?.length? "flex" : "hidden"} w-full items-center justify-evenly mt-5`}>
                        <span className={`text-sm text-gray-700`}>
                            Mostrando <span className="font-semibold text-gray-900">{lastCampaignIndex >= campaigns?.length? campaigns?.length:lastCampaignIndex}</span> de <span className="font-semibold text-gray-900">{campaigns?.length}</span> resultados
                        </span>
                        <div className="inline-flex mt-2 xs:mt-0">
                            <button
                                onClick={() => {setCurrentPage(currentPage - 1)}} 
                                className={`${currentPage === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                                Anterior
                            </button>
                            <button 
                                onClick={() => {setCurrentPage(currentPage + 1)}}
                                
                                className={`${lastCampaignIndex >= campaigns?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                                Siguiente
                            </button>
                        </div>
                    </div>

                    </div>
                </div>

                <h2 className='lg:text-xl mt-8'>Campañas Activas</h2>
                <span className='lg:w-80 w-48 border border-primary-100'></span>

                <p className='text-sm lg:text-lg font-thin mt-4 ml-6'>Arrastre la campaña para determinar el orden de aparición</p>
                
                <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                    <div className='flex flex-col w-full items-center mt-4 space-y-2'>
                        {activeCampaigns.length !== 0? 
                            <div className='flex flex-col w-full items-center space-y-2'>
                                <SortableContext items={activeCampaigns} strategy={verticalListSortingStrategy}>

                                    {activeCampaigns.map((activeCampaign, index) => (
                                        <div className='flex flex-row w-4/5 justify-center space-x-2 max-w-6xl' key={activeCampaign.index}>
                                            <div className='w-2/3 bg-primary-300 h-custom-box lg:h-48 p-3'>
                                                <SortableImage key={activeCampaign.index} id={activeCampaign.id} image={activeCampaign.image} />
                                            </div>
                                            <div className='flex flex-col w-1/3 bg-white space-y-2'>
                                                <div className='bg-primary-300 w-full h-9 lg:h-10 flex justify-center items-center'>
                                                    <h3 className='text-primary-100 text-sm lg:text-lg'>Posición</h3>
                                                </div>

                                                <div className='bg-background w-full h-24 lg:h-36 flex justify-center items-center'>
                                                    <h1 className='text-primary-100 text-3xl font-bold lg:text-6xl'>{index + 1}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </SortableContext>
                                
                                <div className='mt-10'>
                                    <button onClick={updatePositionsActiveCampaigns}
                                    className='w-60 h-8 text-xs sm:text-base sm:h-9 bg-primary-100 text-white rounded font-bold form1:text-xl hover:bg-primary-200'>Editar Posiciones</button>
                                </div>
                            </div>
                            :
                            <div className='text-2xl text-primary-100'>
                                Actualmente no hay campañas activas
                            </div>
                        }
                    </div>
                </DndContext>
                
            </div>
            <FooterAdmin />
        </div>
    )
}

export default CampaignsAdmin;
